import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './FieldGroup.css'

/**
 * Field Group stacks a set of [Field](/components/field/) controls vertically
 * with consistent spacing. Separate sections with a
 * [Field Separator](/components/field-separator/) when needed.
 *
 * @status draft
 * @category form
 * @lightDom true
 *
 * @slot - Default slot for [Field](/components/field/) and [Field Separator](/components/field-separator/) elements.
 *
 * @cssprop [--n-field-group-gap=var(--n-space-l)] - Controls the spacing between fields, using our [spacing tokens](/tokens/#space).
 */
@customElement('nord-field-group')
export default class FieldGroup extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-field-group': FieldGroup
  }
}
